import React, { useState } from 'react'
import styled from 'styled-components'
import { StopConfirmationModal } from './StopConfirmationModal'

const Container = styled.div`
  width: '100%';
`

const Text = styled.div`
  color: #000;
  font-family: 'Proxima-Nova';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.352px;
  text-decoration-line: underline;
  text-align: initial;
  margin-top: 12px;
  cursor: pointer;
  @media (max-width: 600px) {
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.308px;
  }
`

const StopProgram = ({ id }) => {
  const [showStopConfirmation, setStopConfirmation] = useState(false)

  const onClickHandler = (e) => {
    e.preventDefault()
    setStopConfirmation(true)
  }
  return (
    <>
      <Container>
        <Text onClick={onClickHandler}>Stop Program</Text>
      </Container>
      <StopConfirmationModal
        id={id}
        showStopConfirmation={showStopConfirmation}
        setStopConfirmation={setStopConfirmation}
      />
    </>
  )
}

export default StopProgram
